import axios from "axios";

let $axios = axios.create({
    baseURL: window.widget_config && window.widget_config.apiUrl ? window.widget_config.apiUrl : "",
    headers: {
        "Content-Type": "application/json"
    }
});

$axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (errors) => {
        if (errors.response) {
            return Promise.reject(errors.response);
        }
        return Promise.reject(errors);
    }
);

export default $axios;
